import React, { useState, useEffect, useContext, useRef } from 'react';
import DialogBox from '../../../../components/DialogBox';
import * as Yup from 'yup';
import { testFilterResetData } from '../../../../redux/reducers/BRE/AddRuleGroup';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../../../themes/ThemeProvider';
import {
  postFilter,
  resetMessage,
  fetchFilter,
  fetchBasicInfo,
  fetchWorkqueueFields,
} from '../../../../redux/reducers/WorkQueueSetup/index';
import PageLoader from '../../../../components/PageLoader';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';
import { Field, FieldArray, Form, Formik } from 'formik';
import * as yup from 'yup';
import {
  getClientCodeData,
  getCollectorsData,
  getDropDownData,
  getFieldCode,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import SearchFields from '../../../FrameWorks/GlobalFields/DataRepositories/SearchDataRepositories/index';
import BreadCrums from '../../../../util/BreadCrum';
import SqlRuleBuilder from '../../../../components/SqlRuleBuilder';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import { fetchUserDefinedWindows } from '../../../../redux/reducers/EventTactics/EventTactics';
import { getOptions } from '../../../../components/SqlRuleBuilder/utils';
import {
  submissionEnd,
  submissionStart,
} from '../../../../redux/reducers/CommonActions/commonActions';
import TestComponent from './TestComponent';
import AddIcon from '@mui/icons-material/Add';
import {
  TextField,
  Button,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

const Filters = ({ handleNext, handleBack, handleDirty, setTabValue, workQueue, editExisting }) => {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [openTestForm, setOpenTestForm] = useState(false);
  const dirtyRef = useRef(false);
  const {
    addFilterStatus,
    getfilterData,
    wqCode,
    // reportMasterData,
    successMsg,
    errorMsg,
    basicInfoData,
  } = useSelector(({ addWorkQueue }) => addWorkQueue);
  const formDataRef = useRef();
  const [dirtyval, setDirtyVal] = useState(false);
  const filterMethodRef = useRef({});
  const arrayHelperRef = useRef();
  const [deletedRules, setDeletedRules] = useState([]);
  const [open, setOpen] = useState(false);
  const clickedTestRef = useRef('');
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const resultRef = useRef();
  const [isDelete, setIsDelete] = useState(false);
  const [validate, setValidate] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const currentDeleteIndex = useRef(null);
  const initialVal = {
    resultExpCondition:
      getfilterData?.defaultOperator == null ? 'AND' : getfilterData?.defaultOperator,
    sqlRules: [],
    sqlExpression: '',
  };

  const [initialValues, setInitialValues] = useState(initialVal);
  const validationSchema = yup.object().shape({
    sqlRules: Yup.array().of(
      Yup.object().shape({
        field: Yup.mixed().required('Field is required'),
        condition: Yup.mixed().required('Condition is required'),
        value: Yup.mixed().when('condition', {
          is: (val) => {
            return !['isNotBlank', 'isBlank'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        value1: Yup.mixed().when('condition', {
          is: (val) => {
            return ['BETWEEN', 'NOT BETWEEN'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
      }),
    ),
    sqlExpression: Yup.string().test('sqlExpression', 'Result Expression is required', (value) => {
      if (!value && formDataRef.current?.values?.sqlRules?.length > 0) {
        return false;
      } else {
        return true;
      }
    }),
  });
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleResultExpression = (arr, setFieldValue, resultExpCondition) => {
    if (!resultRef.current) {
      const result = arr.map((el, i) => el.ruleCode);
      if (result.length > 0 && resultExpCondition) {
        setFieldValue('sqlExpression', result.join(` ${resultExpCondition} `));
      } else {
        setFieldValue('resultExpCondition', 'AND');
        setFieldValue('sqlExpression', '');
      }
    }
  };
  const handleDeleteRule = () => {
    const i = currentDeleteIndex.current;
    const {
      form: { values, setFieldValue },
    } = arrayHelperRef.current;
    const copyArr = [...values.sqlRules];
    const copyDeleteArr = [...deletedRules];
    if ('workQueueRulesList' in getfilterData) {
      copyDeleteArr.push(getfilterData?.workQueueRulesList[i]?.workqueueRuleId);
    }
    copyArr.splice(i, 1);
    // if (handleExpression) {
    //   handleExpression(copyArr);
    // }
    // setRules(copyArr);
    setDeletedRules(copyDeleteArr.filter(Boolean));
    if (arrayHelperRef.current) {
      arrayHelperRef.current.remove(currentDeleteIndex.current);
      handleResultExpression(copyArr, setFieldValue, values.resultExpCondition);
    }
    setIsDelete(false);
  };

  useEffect(() => {
    if (dirtyRef.current === true || dirtyval) {
      handleDirty(true);
    } else {
      handleDirty(false, 'reset');
    }
  }, [dirtyRef.current, dirtyval]);

  useEffect(() => {
    if (wqCode) {
      dispatch(fetchFilter(wqCode));
    }
  }, [wqCode]);

  const handleValidationClose = () => {
    setValidate(false);
    dispatch(submissionEnd());
  };

  useEffect(() => {
    const newInitialValues = { ...initialValues };
    (newInitialValues.resultExpCondition =
      getfilterData?.defaultOperator == null ? 'AND' : getfilterData?.defaultOperator),
    (newInitialValues.sqlExpression = getfilterData?.ruleExpression);

    const newRules =
      getfilterData?.workQueueRulesList?.length > 0
        ? getfilterData?.workQueueRulesList?.map((el) => {
          return {
            ...el,
            field: {
              ...el,
              repositoryName: el.repositoryName,
              fieldType: el?.fieldType ? el?.fieldType : 'text',
              fieldName: el.fieldName,
            },
            condition: getOptions(el?.fieldType?.toLowerCase())?.filter(
              (e) => e.value === el.filterCondition,
            )[0],
            sqlValue: el.sqlExpression,
            value: el.value,
          };
        })
        : [];
    setInitialValues((prevState) => ({
      ...prevState,
      ...newInitialValues,
      sqlRules: newRules,
    }));
  }, [getfilterData]);
  // }

  useEffect(() => {
    dispatch(getFieldCode());
    dispatch(getCollectorsData());
    dispatch(getDropDownData());
    dispatch(getClientCodeData());
    dispatch(fetchUserDefinedWindows());
  }, []);

  useEffect(() => {
    if (addFilterStatus === 200) {
      setTimeout(() => {
        if (clickedTestRef.current) {
          handleValidationClose();
        }
        !clickedTestRef.current && setTabValue(0);
        dispatch(fetchFilter(wqCode));
        dispatch(resetMessage());
      }, 2500);
    }
  }, [addFilterStatus]);

  const handleTestFormClose = () => {
    dispatch(testFilterResetData());
    setOpenTestForm(false);
  };

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
      setSaveLoading(false);
    }
  }, [errorMsg, successMsg]);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (wqCode) {
      dispatch(fetchBasicInfo(wqCode));
    }
  }, [wqCode]);

  const handleSubmit = (data) => {
    dispatch(submissionStart());
    setSaveLoading(true);
    const payload = {
      defaultOperator: data?.resultExpCondition,
      lastStep: 2, // forcing step 3 no matter what
      ruleExpression: data?.sqlExpression ? data?.sqlExpression : '',
      workQueueRuleRequest:
        data?.sqlRules?.length > 0
          ? data?.sqlRules?.map((item, i) => {
            return {
              fieldName: item?.field?.fieldName,
              fieldType: item?.fieldType
                ? item?.fieldType?.toLowerCase()
                : item?.dataType?.toLowerCase(),
              filterCondition: item?.condition?.value,
              repositoryName: item?.field?.repositoryName,
              ruleCode: item?.ruleCode,
              sqlExpression: item?.sqlValue,
              value: item?.value,
              value1: item?.value1,
              workqueueRuleId: item?.workqueueRuleId ? item?.workqueueRuleId : 0,
            };
          })
          : [],
      workQueueRulesDeleteIds: deletedRules?.length > 0 ? [...new Set(deletedRules)] : [0],
      workqueueId: basicInfoData?.workqueueId ? basicInfoData?.workqueueId : 0,
      workqueueName: basicInfoData?.workqueueName ? basicInfoData?.workqueueName : '',
      isDraft: 'N',
    };
    dispatch(postFilter(payload));
  };
  const handleSub = () => {
    setSaveLoading(true);
    const data = formDataRef.current?.values;
    if (data) {
      const payload = {
        defaultOperator: data?.resultExpCondition,
        lastStep: clickedTestRef.current ? 2 : 3,
        ruleExpression: data?.sqlExpression ? data?.sqlExpression : '',
        workQueueRuleRequest:
          data?.sqlRules?.length > 0
            ? data?.sqlRules?.map((item, i) => {
              return {
                fieldName: item?.field?.globalField,
                fieldType: item?.fieldType
                  ? item?.fieldType?.toLowerCase()
                  : item?.dataType?.toLowerCase(),
                filterCondition: item?.condition?.value,
                repositoryName: item?.field?.repositoryName,
                ruleCode: item?.ruleCode,
                sqlExpression: item?.sqlValue,
                value: item?.value,
                value1: item?.value1,
                workqueueRuleId: item?.workqueueRuleId ? item?.workqueueRuleId : 0,
              };
            })
            : [],
        workQueueRulesDeleteIds: deletedRules?.length > 0 ? [...new Set(deletedRules)] : [0],
        workqueueId: basicInfoData?.workqueueId ? basicInfoData?.workqueueId : 0,
        workqueueName: basicInfoData?.workqueueName ? basicInfoData?.workqueueName : '',
      };
      dispatch(postFilter(payload));
    }
  };

  const handleTest = (values) => {
    const sqlRules =
      values.sqlRules?.length > 0
        ? values.sqlRules?.map((item, i) => {
          return {
            fieldName: item?.field?.fieldName,
            fieldType: item?.fieldType
              ? item?.fieldType?.toLowerCase()
              : item?.dataType?.toLowerCase(),
            filterCondition: item?.condition?.value,
            repositoryName: item?.field?.repositoryName,
            ruleCode: item?.ruleCode,
            sqlExpression: item?.sqlValue,
            value: item?.value,
            value1: item?.value1,
            workqueueRuleId: item?.workqueueRuleId ? item?.workqueueRuleId : 0,
          };
        })
        : [];
    const passValuesTest = {
      reportCode: basicInfoData?.workqueueName,
      result: values?.sqlExpression,
      sqlRules: sqlRules,
      isWorkFilter: true,
    };
    return passValuesTest;
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
        innerRef={formDataRef}
      >
        {(props) => {
          const { values, setFieldValue, errors, dirty, touched, handleBlur, handleChange } = props;
          // handleDirty(dirty);

          const check = JSON.stringify(touched) === '{}' ? false : dirty;
          setDirtyVal(check);
          return (
            <>
              {
                <BreadCrums
                  name={'Work Queue Name'}
                  code={basicInfoData?.workqueueName}
                  description={'Work Queue Description'}
                  descriptionValue={basicInfoData?.workqueueDescription}
                />
              }
              <Form noValidate>
                <FieldArray
                  name="sqlRules"
                  render={(arrayHelpers) => {
                    return (
                      <>
                        {values.sqlRules.map((rule, idx) => {
                          const fieldName = `sqlRules[${idx}]`;
                          return (
                            <div key={idx}>
                              <Field
                                key={idx}
                                name={fieldName}
                                component={SqlRuleBuilder}
                                index={idx}
                                isReports={true}
                                handleDelete={() => {
                                  setIsDelete(true);
                                  currentDeleteIndex.current = idx;
                                  arrayHelperRef.current = arrayHelpers;
                                  dirtyRef.current = true;
                                }}
                              />
                            </div>
                          );
                        })}
                        <div className="table-header new-standard-textfields mt-3">
                          {/* <Typography variant="h4"></Typography> */}
                          <RadioGroup
                            aria-label="resultExpCondition"
                            name="resultExpCondition"
                            value={values.resultExpCondition}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              const result = values.sqlRules.map((el, i) => el.ruleCode);
                              resultRef.current = false;
                              setFieldValue('sqlExpression', result.join(` ${e.target.value} `));
                            }}
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              flexDirection: 'row',
                            }}
                          >
                            <FormControlLabel
                              value="AND"
                              control={<Radio disabled={values.resultExpCondition == ''} />}
                              label="AND"
                            />
                            <FormControlLabel
                              value="OR"
                              control={<Radio disabled={values.resultExpCondition == ''} />}
                              label="OR"
                            />
                          </RadioGroup>

                          <div>
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setOpen(true);
                              }}
                            >
                              <AddIcon />
                              Add Filter Rule
                            </Button>
                          </div>
                        </div>
                      </>
                    );
                  }}
                />
                <div className="d-flex justify-content-space-between align-items-center mt-0 global-field-textfields new-standard-textfields">
                  <div className="col-md-6 col-lg-4 col-xl-4 pl-0 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Result Expression"
                      margin="dense"
                      name="sqlExpression"
                      variant="outlined"
                      label="Result Expression"
                      onBlur={handleBlur}
                      value={values?.sqlExpression}
                      // required
                      required={values.sqlRules.length > 0}
                      disabled={values.sqlRules.length === 0}
                      onChange={(e, value) => {
                        setFieldValue('sqlExpression', e.target.value);
                        if (e.target.value.length > 0) {
                          resultRef.current = true;
                          setFieldValue('resultExpCondition', '');
                        }
                        // setResultSql(e.target.valu e);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // error={touched?.sqlExpression && Boolean(errors.sqlExpression)}
                      error={values.sqlRules.length > 0 ? Boolean(errors.sqlExpression) : ''}
                      fullWidth
                    />
                    <FormHelperText style={{ color: 'red' }} variant="outlined">
                      {values.sqlRules.length > 0 && errors.sqlExpression
                        ? errors.sqlExpression
                        : ''}
                    </FormHelperText>
                  </div>
                  <Button
                    variant="outlined"
                    className={`ml-auto search-btn ${classes.buttonRoot} mb-4`}
                    // disabled={!values?.sqlExpression}
                    onClick={() => {
                      // handleSubmit(values);
                      clickedTestRef.current = true;
                      setOpenTestForm(true);
                    }}
                  >
                    Test
                  </Button>
                </div>
                <div className="d-flex justify-content-center new-standard-textfields">
                  <Button
                    type="button"
                    onClick={() => {
                      handleBack();
                      dispatch(fetchWorkqueueFields(wqCode));
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {isDraftReport === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    // disabled={roleAccess || enabledSubmission}
                    disabled={!values?.sqlRules?.length > 0}
                    onClick={() => {
                      clickedTestRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  {/* {values?.sqlRules && values?.sqlRules?.length > 0 ? ( */}

                  <Button
                    type="submit"
                    variant="outlined"
                    className={`mx-1 search-btn ${classes.buttonRoot}`}
                    onClick={() => {
                      clickedTestRef.current = false;
                    }}
                    disabled={!values?.sqlRules?.length > 0}
                    // disabled={roleAccess || enabledSubmission}
                  >
                    Finish
                  </Button>
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Fields</b>
                      </p>
                      {
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.workqueueName}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.workqueueDescription}
                        />
                      }
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    isReportsFilter={true}
                    isReports={true}
                    resultExpCondition={values.resultExpCondition}
                    setRules={(value) => {
                      setFieldValue('sqlRules', value);
                    }}
                    rules={values.sqlRules}
                    resultRef={resultRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                    setInitialValues={setInitialValues}
                    setFieldValue={setFieldValue}
                    filterValues={values}
                    filterMethodRef={filterMethodRef}
                  />
                </DialogBox>
                {values.sqlRules[currentDeleteIndex.current] && (
                  <DeleteTableRecordPopup
                    open={isDelete}
                    dialogClose={handleDeleteClose}
                    title="Delete SQL Rule"
                    value={`Are you sure you want to delete the ${
                      values.sqlRules[currentDeleteIndex.current].ruleCode
                    } Filter Rule?`}
                    handleSubmit={handleDeleteRule}
                  />
                )}
                <DialogBox
                  open={openTestForm}
                  dialogClose={handleTestFormClose}
                  title={
                    <>
                      <span>
                        <b>{'Run Test For'} :</b>
                      </span>
                      <span className="result-expression">{values?.sqlExpression}</span>
                    </>
                  }
                  maxWidth="lg"
                >
                  <TestComponent passValuesTest={handleTest(values)} isWorkQueueTest={true} />
                </DialogBox>
              </Form>
              <DeleteTableRecordPopup
                open={validate}
                dialogClose={handleValidationClose}
                title="Warning !"
                value={`Filter Rule hasn't been added, Would you like to Skip and Continue?`}
                handleSubmit={handleSub}
              />
            </>
          );
        }}
      </Formik>
      {saveLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default Filters;
